// extracted by mini-css-extract-plugin
export default {"container":"Card--container--slHz6"};